import { ComponentPropsWithoutRef } from "react";
import * as styles from "./SectionBlockCallout.css";
import Grid from "~/components/globals/Grid";
import { SectionBlockCallout as ISectionBlockCallout } from "~/sanity/types";
import { Heading } from "~/components/elements/Heading";
import { Paragraph } from "~/components/elements/Paragraph";

export type SectionBlockCalloutProps = ComponentPropsWithoutRef<"div"> &
  styles.WrapperVariants & {
    data: ISectionBlockCallout;
  };

export const SectionBlockCallout = ({
  data,
  theme = "dark",
  ...props
}: SectionBlockCalloutProps) => {
  return (
    <section {...props}>
      <Grid>
        <div className={styles.wrapper({ theme })}>
          <Heading as="h2" size="h1" uppercase>
            {data.text}
          </Heading>
          {data.credit && (
            <div className={styles.credit}>
              <Heading as="h3" size="h4">
                {"→"}
              </Heading>
              <Heading as="h3" size="h4">
                {data.credit}
              </Heading>
              <Heading as="h3" size="h4">
                {"←"}
              </Heading>
            </div>
          )}
        </div>
      </Grid>
    </section>
  );
};
